import React from 'react'
import classnames from 'classnames'
import styles from './index.module.less'
interface IProps {
  module: 'cost' | 'multiple' | 'fast' | 'safe' | 'professional'
  special?: boolean
  declare: string
  explain: string
}

export default function Item(props: IProps) {
  const { special, module, declare, explain } = props
  return (
    <div className={styles.item}>
      <i className={classnames(styles.image, styles[module], { [styles.others]: special })}></i>
      <div className={styles.desc}>
        <span className={styles.declare}>{declare}</span>
        <span className={styles.explain}>{explain}</span>
      </div>
    </div>
  )
}
